import { animate, style, transition, trigger } from '@angular/animations';

export const fadeAnimation = trigger('fade', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(10px)',
      position: 'relative',
    }),
    animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
  ]),
  transition(':leave', [
    style({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 0,
    }),
    animate('500ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' })),
  ]),
]);
